module.exports = __webpack_public_path__ + "static/media/featuresection4.9c610b89.png";